export const EVENT_NAME = {
  PAGEVIEW: 'PAGEVIEW',
  ACCOUNTCREATE: 'ACCOUNT_CREATE',
  LOGIN: 'LOGIN',
  QRV_FAILURE: 'QRV_FAILURE',
  PHONE_NUMBER_ERROR: 'PHONE_NUMBER_ERROR',
  VERIFICATION_CODE_ERROR: 'VERIFICATION_CODE_ERROR',
  PHONE_ALREADY_ASSOCIATED_ERROR: 'PHONE_ALREADY_ASSOCIATED_ERROR',
};
